import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';

import { trackMissingDestination } from 'actions';
import type { RootState } from 'reducers/types';
import { getCurrentLocale } from 'selectors';

import { DEFAULT_LOCALE, SELECT_INSTITUTION_PATH } from '../../constants';

type RedirectToSelectInstitutionProps = ConnectedProps<typeof connector>;

const RedirectToSelectInstitutionComponent = ({
  locale = DEFAULT_LOCALE,
  trackMissingDestination,
}: RedirectToSelectInstitutionProps) => {
  trackMissingDestination();
  window.location.assign(`${SELECT_INSTITUTION_PATH}?language=${locale}`);
  return null;
};

const mapStateToProps = (state: RootState) => ({
  locale: getCurrentLocale(state),
});

const mapDispatchToProps = {
  trackMissingDestination,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
const RedirectToSelectInstitution = connector(
  RedirectToSelectInstitutionComponent,
);

export { RedirectToSelectInstitution };
